// extracted by mini-css-extract-plugin
export default {"gallery":"c-o_fP","gallery__header":"c-o_fQ","gallery__thumbs":"c-o_fR"};